export const openInNewTab = (url: string | URL) => {
  window.open(url, '_blank', 'noopener,noreferrer');
};
